module.exports = __webpack_public_path__ + "media/images/icons/ic-picture-upload-77db816344075c2344c76684c9e61ed7.svg";